import { useState } from 'react';
import { ClinicData, ClinicId } from '../types';
import { getClinicConfig } from '../clinicPalette';

interface Props {
  clinics: ClinicData[];
  selected: Set<ClinicId>;
  onApply: (selected: Set<ClinicId>) => void;
}

export default function ClinicFilter({ clinics, selected, onApply }: Props) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<Set<ClinicId>>(new Set(selected));

  const totalClinics = clinics.length;
  const isFiltered = selected.size < totalClinics;

  const handleOpen = () => {
    setDraft(new Set(selected));
    setOpen(true);
  };

  const toggle = (clinicId: ClinicId) => {
    setDraft((prev) => {
      const next = new Set(prev);
      if (next.has(clinicId)) next.delete(clinicId);
      else next.add(clinicId);
      return next;
    });
  };

  const handleSelectAll = () => {
    setDraft(new Set(clinics.map((c) => c.id)));
  };

  const handleApply = () => {
    onApply(draft);
    setOpen(false);
  };

  return (
    <>
      <button type="button" className="filter-btn" onClick={handleOpen}>
        <span>⚙</span> סנן קופה
        {isFiltered && (
          <span className="filter-badge num-eng">
            {selected.size}/{totalClinics}
          </span>
        )}
      </button>

      {open && (
        <div
          className="modal-backdrop"
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <div className="modal">
            <h3 className="modal-title">סנן לפי קופה</h3>
            <div className="modal-options">
              {clinics.map((c) => {
                const cfg = getClinicConfig(c.id);
                return (
                  <label key={c.id}>
                    <input
                      type="checkbox"
                      checked={draft.has(c.id)}
                      onChange={() => toggle(c.id)}
                    />
                    <span className="pill-dot" style={{ background: cfg.hex }} />
                    <span className="modal-clinic-name">{cfg.displayName}</span>
                    <span className="modal-clinic-count num-eng">{c.count.toLocaleString('en-US')}</span>
                  </label>
                );
              })}
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={handleSelectAll}>
                בחר הכל
              </button>
              <button type="button" className="btn-primary" onClick={handleApply}>
                הצג
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
